'use strict';

angular.module('sharecrf-version', [])
    .service('ShareCrfVersion', [function() {
        var data = {
            apiVersion: null,
        };

        return {
            setVersion: function(value) {
                data.apiVersion = value;
            },
            get: function() {
                return data;
            }
        };
    }])
    .factory('ShareCrfVersionInterceptor', ['ShareCrfVersion', '$document', function(ShareCrfVersion, $document) {
        var hostParts = $document[0].location.host.split('.');
        hostParts.shift();

        var sharecrfApiUrlPart = '.' + hostParts.join('.') + '/api/';

        function isApiCall(calledUrl) {
            return calledUrl.indexOf(sharecrfApiUrlPart) > -1; // This is a ShareCRF API call
        }

        return {
            response: function(response) {
                if (isApiCall(response.config.url)) {
                    var apiVersion = response.headers('X-Api-Build-SHA');
                    ShareCrfVersion.setVersion(apiVersion);
                }

                return response;
            },
        };
    }])
    // Obtain API version (SHA)
    .config(['$httpProvider', function($httpProvider) {
        $httpProvider.interceptors.push('ShareCrfVersionInterceptor');
    }]);
